module.exports = __webpack_public_path__ + "static/media/drumnow-5.080e0e24.jpg";